import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { DecisionState } from '@enums';
import { useDecisions } from '../decision/decisions';

export function IndexingDecisions() {
  const intl = useIntl();

  const defaultPreFilters = [
    {
      field: 'state.id',
      operation: ApiFilterOperation.EQ,
      value: DecisionState.INDEXING,
    },
  ];

  const { evidenceBag } = useDecisions({
    evidenceProps: {
      tableProps: {
        defaultPreFilters,
        tableName: intl.formatMessage({
          id: 'ES__INDEXING_DECISIONS__TABLE__TITLE',
          defaultMessage: 'Rozhodnutí - indexace',
        }),
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
